import { z } from 'zod';
import { AuditSchema } from '../settings/audit-schema';

export const LessonSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'El título de la lección es obligatorio'),
  type: z.enum(['video', 'text', 'file']).default('video'), // Para compatibilidad
  contentType: z.enum(['video', 'text', 'file']).default('video'), // Usado en CourseEditor
  content: z.string().min(1, 'El contenido o ID de video es obligatorio').optional(), // Para compatibilidad
  videoId: z.string().optional(), // Usado en CourseEditor y Player
  duration: z.number().default(0), // en minutos
  isFreePreview: z.boolean().default(false),
  order: z.number().default(0),
});

export const ModuleSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'El título del módulo es obligatorio'),
  order: z.number().default(0),
  lessons: z.array(LessonSchema).default([]),
});

export const CourseSchema = z.object({
  // Metadata
  ownerId: z.string(),
  title: z.string().min(3, 'El título es muy corto'),
  slug: z.string().min(3),
  tagline: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  thumbnail: z.string().nullable().optional(),
  coverImage: z.string().nullable().optional(),
  
  // Pricing (Tied to ledger logic)
  price: z.number().min(0).default(0),
  currency: z.enum(['USD', 'BS']).default('USD'),
  
  // Structure
  modules: z.array(ModuleSchema).default([]),
  
  // Settings
  isPublished: z.boolean().default(false),
  videoLibraryId: z.string().nullable().optional(), // Bunny.net Library ID
  promoVideoId: z.string().nullable().optional(), // Bunny.net Promo Video ID
  enrollmentCount: z.number().default(0),
  
  // Branding
  accentColor: z.string().nullable().optional(),

  // Certificate
  certificatePdfUrl: z.string().nullable().optional(),

  // Audit
  audit: AuditSchema.optional(),
});

export type Lesson = z.infer<typeof LessonSchema>;
export type Module = z.infer<typeof ModuleSchema>;
export type Course = z.infer<typeof CourseSchema>;
export type CourseWithId = Course & { id: string };
